import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

// Version autosuggest source for the IT Components side of the Dependencies
// picker — approved versions of a global component plus this org's own
// pending submissions (mirrors the visibility rule in
// Api::V1::Organizations::GlobalComponentVersionsController). Keyed by
// global_component_id so several components' suggestions can be cached at
// once without clobbering each other.
export const useOrgGlobalComponentVersionsStore = defineStore('orgGlobalComponentVersions', {
  state: () => ({
    byComponent: {}, // globalComponentId -> { records, loading, fetchedAt }
  }),

  actions: {
    entryFor(globalComponentId) {
      this.byComponent[globalComponentId] ||= { records: [], loading: false, fetchedAt: null }
      return this.byComponent[globalComponentId]
    },

    async fetchIfNeeded(organizationId, globalComponentId) {
      const entry = this.entryFor(globalComponentId)
      if (entry.fetchedAt !== null) return

      entry.loading = true
      try {
        const { axiosRequest } = useRequest()
        const path = `/api/v1/organizations/${organizationId}/global_components/${globalComponentId}/versions`
        const res = await axiosRequest('GET', path, {}, false)
        if (!res.js_error && res.response.success) {
          entry.records = res.response.data
          entry.fetchedAt = Date.now()
        }
      } finally {
        entry.loading = false
      }
    },
  },
})
